var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_1389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7866 17.6C23.7851 18.5772 23.3985 19.514 22.7114 20.2049C22.0243 20.8958 21.0929 21.2845 20.1213 21.2857H0.181366V6.68663C0.182829 5.70933 0.569459 4.77247 1.25651 4.08142C1.94356 3.39036 2.87499 3.00147 3.84663 3H23.7866V17.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2932 13.8558H18.8073C18.8506 13.8558 18.9521 13.841 18.9917 13.841C19.1457 13.8078 19.2834 13.7214 19.3808 13.597C19.4783 13.4725 19.5295 13.3177 19.5256 13.1593C19.5252 13.0019 19.4724 12.8492 19.3756 12.7255C19.2788 12.6018 19.1437 12.5142 18.9917 12.4767C18.931 12.4641 18.8691 12.4591 18.8073 12.4619H17.2932V13.8558Z",
    fill: "url(#paint0_linear_448_1389)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6357 4.23355C17.9393 4.2338 17.2715 4.51217 16.7791 5.00747C16.2867 5.50277 16.0099 6.17448 16.0096 6.87495V9.61744H19.7173C19.8043 9.61453 19.8913 9.6195 19.9774 9.63224C20.8146 9.67584 21.4342 10.1108 21.4342 10.8658C21.4342 11.4612 21.0165 11.9685 20.2355 12.0715V12.1002C21.0866 12.1586 21.7358 12.6372 21.7358 13.3773C21.7358 14.1759 21.0147 14.698 20.0622 14.698H15.9949V20.0652H19.8474C20.5438 20.065 21.2115 19.7866 21.704 19.2913C22.1964 18.796 22.4732 18.1243 22.4734 17.4238V4.23355H18.6357Z",
    fill: "url(#paint1_linear_448_1389)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3421 11.04C19.344 10.8886 19.2906 10.7418 19.192 10.6274C19.0934 10.5131 18.9565 10.4391 18.8073 10.4196C18.7787 10.4196 18.7068 10.4048 18.6634 10.4048H17.2932V11.6781H18.6644C18.7128 11.682 18.7614 11.6773 18.8082 11.6642C18.9579 11.6444 19.0952 11.5698 19.1936 11.4546C19.2921 11.3395 19.345 11.1919 19.3421 11.04Z",
    fill: "url(#paint2_linear_448_1389)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1205 4.23355C3.4241 4.2338 2.75629 4.51217 2.26386 5.00747C1.77142 5.50277 1.49467 6.17448 1.49442 6.87495V13.3876C2.23209 13.7502 2.99465 13.982 3.75997 13.982C4.66914 13.982 5.15969 13.4311 5.15969 12.6762V9.6035H7.41046V12.6641C7.41046 13.8541 6.67281 14.826 4.17768 14.826C3.26812 14.8266 2.36196 14.7145 1.47968 14.4921V20.0504H5.33212C5.67698 20.0504 6.01846 19.9821 6.33709 19.8493C6.65566 19.7166 6.94521 19.522 7.18904 19.2768C7.43286 19.0314 7.62635 18.7402 7.75829 18.4198C7.89029 18.0993 7.95818 17.7558 7.95818 17.409V4.23355H4.1205Z",
    fill: "url(#paint3_linear_448_1389)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.378 4.23355C10.6824 4.23503 10.0158 4.51393 9.52433 5.00911C9.0329 5.50428 8.75679 6.17528 8.75656 6.87495V10.3269C9.42045 9.76121 10.5749 9.3995 12.4356 9.48573C13.1316 9.53013 13.8222 9.63693 14.4992 9.80476V10.9177C13.8832 10.5857 13.2046 10.388 12.5075 10.3372C11.094 10.2351 10.243 10.9316 10.243 12.1512C10.243 13.3848 11.094 14.0813 12.5075 13.9653C13.2032 13.9071 13.8804 13.7097 14.4992 13.3848V14.4977C13.8224 14.667 13.1317 14.7738 12.4356 14.8168C10.5749 14.9039 9.42045 14.5385 8.75656 13.9746V20.0708H12.609C13.3054 20.0705 13.9732 19.7922 14.4656 19.2969C14.958 18.8016 15.2348 18.1298 15.2351 17.4294V4.23355H11.378Z",
    fill: "url(#paint4_linear_448_1389)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_1389",
    x1: 16.1757,
    y1: 13.2397,
    x2: 22.6602,
    y2: 13.2397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_448_1389",
    x1: -190837,
    y1: -1190680,
    x2: -190381,
    y2: -1190680,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_448_1389",
    x1: -17652,
    y1: -7035.92,
    x2: -17507.7,
    y2: -7035.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_448_1389",
    x1: 1.46555,
    y1: 12.2965,
    x2: 8.07366,
    y2: 12.2965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_448_1389",
    x1: 8.67302,
    y1: 11.9044,
    x2: 15.0867,
    y2: 11.9044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_1389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.2857,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardJcb);
export default __webpack_public_path__ + "static/media/card_jcb.886369162715975cac2d909146a3fc3c.svg";
export { ForwardRef as ReactComponent };